const STATIC_CONTENTS = {
  ALL: { en: 'All', fr: 'Tout' },
  PLEASE_SELECT: {
    en: 'Please select a category...',
    fr: 'Veuillez sélectionner une catégorie',
  },
  RELATED_ARTICLES: { en: 'Related articles', fr: 'Articles connexes' },
  EXPLORE_SIMILAR: { en: 'Explore similar articles', fr: 'Explorez des articles similaires' },
  VIEW_ARTICLES: { en: 'View all articles', fr: 'Voir tous les articles' },
  MORE_STORIES: { en: 'More stories', fr: 'Plus d’histoires' },
  AUTHOR: {
    BY: {
      en: 'By',
      fr: 'Par',
    },
    TEAM_MEMBERS: {
      en: '& team members',
      fr: 'et les membres de l’équipe',
    },
    TITLE: {
      en: 'Authored by:',
      fr: 'Auteur:',
    },
    MEET: {
      en: 'Meet the author',
      fr: "Rencontrez l'auteur",
    },
  },
  FEATURED_STORIES: {
    READ_STORY: {
      en: 'Read Story',
      fr: "Lire l'histoire",
    },
  },
  SOCIAL: {
    TITLE: {
      en: 'Share article:',
      fr: 'Partager cet article :',
    },
    LINKS: {
      linkedin: 'https://www.linkedin.com/shareArticle?mini=true&title=',
      facebook: 'https://www.facebook.com/sharer/sharer.php?u=',
      twitter: 'https://twitter.com/intent/tweet?text=',
      medium: 'https://medium.com/@telusdigital',
    },
  },
  ARTICLES: {
    SHOW_MORE: {
      en: 'Show more',
      fr: 'Voir plus',
    },
  },
  BREADCRUMBS: {
    HOME_LINK: {
      en: 'Home',
      fr: 'Accueil',
    },
  },
  DEFAULT_PROPS: {
    // Place holding default prop value
    SLUG: '',
    AUTHOR: {
      TITLE: '',
      PROFILE_IMAGE: {
        URL: '',
        DESCRIPTION: '',
      },
      NAME: '',
      BIO: '',
      AUTHOR_LINK: '',
    },
    ARTICLE: {
      IMAGE: {
        URL: '',
      },
      VIDEO: {
        VIDEO_ID: '',
        VIDEO_LENGTH: 0,
      },
      TITLE: '',
      PUBLISHDATE: '',
      INTCMP: '',
    },
    LAZYLOAD_IMG: {
      TITLE: '',
      DESCRIPTION: '',
      SRC: '',
    },
    HERO_BANNER: {
      IMAGESRC: '',
      TITLE: '',
      DESCRIPTION: '',
    },
    SEO: {
      METATITLE: '',
      DESCRIPTION: '',
      KEYWORDS: '',
      IMAGE: '',
    },
  },
}

export default STATIC_CONTENTS
